import { useState } from 'react'
import styled from 'styled-components'

import { useMyTicketList } from '~/features/mypage/queries/useMyInfo'
import { type Filters } from '~/features/mypage/types/my-page'
import Sii2 from '~/shared/assets/images/sii2.png'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import Pagination from '~/shared/components/pagination/Pagination'
import EntryTicket from '~/shared/components/tickets/EntryTicket'
import theme from '~/shared/styles/theme'

function TicketInfo() {
  const [filters, setFilters] = useState<Filters>({
    page: 1,
    row_per_page: 10,
  })

  const { data: ticketList, isLoading } = useMyTicketList(filters)

  if (isLoading) return <LoadingScreen />

  const { user_event_ticket_list, pageInfo } = ticketList!

  const handleChangePage = (
    _event: React.ChangeEvent<unknown>,
    page: number,
  ) => {
    setFilters((prevFilters) => ({ ...prevFilters, page }))
  }

  return (
    <Wrapper>
      {user_event_ticket_list.length !== 0 && (
        <>
          <MainTitle>구매한 입장권</MainTitle>
          <Desc>
            행사장에 들어오시기전에 미리 QR코드를 준비해 주세요. 입장 완료된
            티켓은 타인에게 공유, 재사용이 불가합니다.
          </Desc>
        </>
      )}
      {user_event_ticket_list.length === 0 && (
        <>
          <NoDataWrapper>
            <SiiImage src={Sii2} alt="sii2" />
            <Description>구매하신 입장권이 없습니다.</Description>
          </NoDataWrapper>
        </>
      )}
      {user_event_ticket_list.map((ticket) => (
        <EntryTicket key={ticket.id} ticket={ticket} />
      ))}
      <Pagination
        page={filters.page}
        count={pageInfo.max_page}
        onChange={handleChangePage}
      />
    </Wrapper>
  )
}

export default TicketInfo

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  width: 100%;

  @media ${theme.device.medium} {
    gap: 48px;
  }
`
const MainTitle = styled.h1`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 42px;
  font-weight: 700;
  line-height: 58px;

  @media ${theme.device.medium} {
    font-size: 28px;
    line-height: 39px;
  }
`

const Desc = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;

  @media ${theme.device.medium} {
    font-size: 15px;
    line-height: 21px;
  }
`

const NoDataWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
`
const SiiImage = styled.img`
  width: 580px;
  margin: 0 auto;

  @media ${theme.device.medium} {
    width: 100%;
  }
`

const Description = styled.div`
  margin: 0 auto;

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 36px;
  font-weight: 500;
  line-height: 58.8px;

  @media ${theme.device.medium} {
    font-size: 24px;
    text-align: center;
  }
`
